// @ts-check
import validateFirstName from 'libs/validations/validateFirstName';
import { Contact } from '../constants/contact';
import { USER_CUSTOMERS_ERR_MSG_EMPTY } from 'constants/validMsg';
import { USER_FIRST_NAME_ERR_MSG_LENGTH } from 'constants/validMsg';
import { USER_LAST_NAME_ERR_MSG_LENGTH } from 'constants/validMsg';
import validateLastName from 'libs/validations/validateLastName';
import validateEmail from 'libs/validations/validateEmail';

/**
 * @function checkContactValid
 * @param {ContactInfo} contact
 * @param {function} setValid
 * @returns {void}
 */
function checkContactValid(contact, setValid) {
	/** @type {ContactValid} */
	const fname = validateFirstName(contact[Contact.FirstName]);

	setValid((/** @type {ContactValid} */ prev) => ({
		...prev,
		[Contact.FirstName]: {
			isErr: fname.isErr,
			errMsg: fname.errMsg,
			canNotSave: fname.isErr ? true : false,
		},
	}));

	if (contact[Contact.FirstName].trim().length === 0) {
		setValid((/** @type {ContactValid} */ prev) => ({
			...prev,
			[Contact.FirstName]: {
				isErr: true,
				errMsg: USER_FIRST_NAME_ERR_MSG_LENGTH,
				canNotSave: true,
			},
		}));
	}

	/** @type {ContactValid} */
	const lname = validateLastName(contact[Contact.LastName]);

	setValid((/** @type {ContactValid} */ prev) => ({
		...prev,
		[Contact.LastName]: {
			isErr: lname.isErr,
			errMsg: lname.errMsg,
			canNotSave: lname.isErr ? true : false,
		},
	}));

	const isNotEmpty = contact[Contact.LastName].trim().length === 0;

	setValid((/** @type {ContactValid} */ prev) => ({
		...prev,
		[Contact.LastName]: {
			isErr: isNotEmpty,
			errMsg: USER_LAST_NAME_ERR_MSG_LENGTH,
			canNotSave: isNotEmpty,
		},
	}));

	const hasNotCompanies = contact[Contact.Companies].length === 0;

	setValid((/** @type {ContactValid} */ prev) => ({
		...prev,
		[Contact.Companies]: {
			isErr: hasNotCompanies,
			errMsg: USER_CUSTOMERS_ERR_MSG_EMPTY,
			canNotSave: hasNotCompanies,
		},
	}));

	const emailWork = validateEmail(contact[Contact.EmailWork]);

	setValid((/** @type {ContactValid} */ prev) => ({
		...prev,
		[Contact.EmailWork]: {
			isErr: emailWork.isErr,
			errMsg: emailWork.errMsg,
			canNotSave: emailWork.isErr ? true : false,
		},
	}));

	const emailPersonal = validateEmail(contact[Contact.EmailPersonal]);

	setValid((/** @type {ContactValid} */ prev) => ({
		...prev,
		[Contact.EmailPersonal]: {
			isErr: emailPersonal.isErr,
			errMsg: emailPersonal.errMsg,
			canNotSave: emailPersonal.isErr ? true : false,
		},
	}));

	const emailOther = validateEmail(contact[Contact.EmailOther]);

	setValid((/** @type {ContactValid} */ prev) => ({
		...prev,
		[Contact.EmailOther]: {
			isErr: emailOther.isErr,
			errMsg: emailOther.errMsg,
			canNotSave: emailOther.isErr ? true : false,
		},
	}));

	// const hasNotContactType = contact[Contact.ContactTypes].length === 0;

	// setValid((/** @type {ContactValid} */ prev) => ({
	// 	...prev,
	// 	[Contact.ContactTypes]: {
	// 		isErr: hasNotContactType,
	// 		errMsg: USER_CONTACTTYPES_ERR_MSG_EMPTY,
	// 		canNotSave: hasNotContactType,
	// 	},
	// }));
}

export default checkContactValid;
